import { createBrowserRouter, Navigate } from 'react-router-dom';
import { ProtectedRoute } from '@/components/auth/ProtectedRoute';
import { PublicRoute } from '@/components/auth/PublicRoute';
import { AuthLayout } from '@/components/layout/AuthLayout';
import { AdminLayout } from '@/components/layout/AdminLayout';
import { LoginPage } from '@/pages/auth/LoginPage';
import { DashboardPage } from '@/pages/dashboard/DashboardPage';
import { PendingReviewsPage } from '@/pages/reviews/PendingReviewsPage';
import { ReviewDetailPage } from '@/pages/reviews/ReviewDetailPage';
import { InquiriesPage } from '@/pages/inquiries/InquiriesPage';
import { InquiryDetailPage } from '@/pages/inquiries/InquiryDetailPage';
import { MessageDetailPage } from '@/pages/messages/MessageDetailPage';
import { MessagesPage } from '@/pages/messages/MessagesPage';
import { UsersPage } from '@/pages/users/UsersPage';
import { UserDetailPage } from '@/pages/users/UserDetailPage';

export const router = createBrowserRouter([
  {
    element: <PublicRoute />,
    children: [
      {
        element: <AuthLayout />,
        children: [
          {
            path: '/login',
            element: <LoginPage />,
          },
        ],
      },
    ],
  },
  {
    element: <ProtectedRoute />,
    children: [
      {
        element: <AdminLayout />,
        children: [
          {
            path: '/',
            element: <Navigate to="/dashboard" replace />,
          },
          {
            path: '/dashboard',
            element: <DashboardPage />,
          },
          {
            path: '/reviews/pending',
            element: <PendingReviewsPage />,
          },
          {
            path: '/reviews/:userId',
            element: <ReviewDetailPage />,
          },
          {
            path: '/inquiries',
            element: <InquiriesPage />,
          },
          {
            path: '/inquiries/:inquiryId',
            element: <InquiryDetailPage />,
          },
          {
            path: '/messages',
            element: <MessagesPage />,
          },
          {
            path: '/messages/:conversationId',
            element: <MessageDetailPage />,
          },
          {
            path: '/users',
            element: <UsersPage />,
          },
          {
            path: '/users/:userId',
            element: <UserDetailPage />,
          },
        ],
      },
    ],
  },
  {
    path: '*',
    element: <Navigate to="/dashboard" replace />,
  },
]);
